
// The Tender presentation edit functions
var TECL_UserTenderPresentationEdit = {

  // Initialise the Tenders edit page
  Initialise: function() {
    TECL_DateTime.InitialiseDateTimePickers("#addContactRequestDialog");

    TECL_UserTenderPresentationEdit.UpdateContinueButtons();

    $("#continueDialogContinueBtn").click(function() {
      TECL_UserTenderPresentationEdit.ContinueSelected();
      $("#continueDialog").modal("hide");
    });

    var jumpPoint = $("#JumpPoint").val();
    if (jumpPoint && jumpPoint == 1) {
      $("html,body").animate({ scrollTop: $("#scrollToSupplierMarker").offset().top }, "slow");
    } else {
      window.scrollTo(0, 0);
    }
  },

  // Display the continue dialog
  DisplayContinueDialog: function() {
    $("#continueDialog").modal("show");
  },

  // Presentation continue button selected 
  ContinueSelected: function() {
    var tenderId = $("#TenderId").val();

    if (tenderId) {

      if (TECL_Master.AddLock("ContinueSelectedOnPresentation")) {

        if (TECL_UserTenderPresentationEdit.ValidatePage()) {
          $.ajax({
            url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnPresentation",
            dataType: "json",
            type: "POST",
            data: {
              tenderId: tenderId
            },
            error: function(exc) {
              TECL_Master.ClearLock("ContinueSelectedOnPresentation");
            },
            success: function(saveData) {
              TECL_Master.ClearLock("ContinueSelectedOnPresentation");
              if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                window.location = saveData.NextStageUrl;
              } else {
                TECL_Master.ShowErrorDialog("Failed to save stage change.");
              }
            }
          });
        } else {
          TECL_Master.ClearLock("ContinueSelectedOnPresentation");
          $("#validationErrorDialog").modal("show");
        }
      }
    }
  },

  // Validate the current page
  ValidatePage: function() {
    var numberOfAwarded = 0;
    var anySuppliersWithNonSelectStatus = false;

    $("#tenderSummariesTable").find("[name=supplierStatusButtons]").each(function() {
      if (!$(this).find("[name=RejectAwardButtons]").hasClass("hidden")) {
        anySuppliersWithNonSelectStatus = true;
      } else if (!$(this).find("[name=UndoAwardLink]").hasClass("hidden")) {
        numberOfAwarded += 1;
      }
    });

    var isValid = numberOfAwarded === 1 && !anySuppliersWithNonSelectStatus;
    return isValid;
  },

  // Return true if 1 or less items are left if all others are rejected
  IsLastRejection: function() {
    var totalNumberItems = 0;
    var numberItemsRejected = 0;

    $("#tenderSummariesTable").find("[name=supplierStatusButtons]").each(function() {
      totalNumberItems += 1;

      if (!$(this).find("[name=UndoRejectLink]").hasClass("hidden")) {
        numberItemsRejected += 1;
      }
    });

    return (totalNumberItems - numberItemsRejected) <= 1;
  },

  // Change the supplier status in the tender to the supplied value
  ChangeSupplierTenderStatus: function(supplierTenderId, rowId, newStatus) {

    var $parent = $("#" + rowId);
    if ($parent && $parent.hasClass("reject-select-disabled")) {
      return;
    }

    if (supplierTenderId) {
      if (TECL_Master.AddLock("ChangeSupplierTenderStatus")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ChangeTenderSupplierStatus",
          dataType: "json",
          type: "POST",
          data: {
            supplierTenderId: supplierTenderId,
            newStatus: newStatus
          },
          error: function(exc) {
            TECL_Master.ClearLock("ChangeSupplierTenderStatus");
          },
          success: function(result) {
            TECL_Master.ClearLock("ChangeSupplierTenderStatus");
            if (result && result === true) {

              var $row = $("#" + rowId);

              if (newStatus === "reject") {

                $row.find("[name=RejectAwardButtons]").addClass("hidden");
                $row.find("[name=UndoRejectLink]").removeClass("hidden");
                $row.find("[name=UndoAwardLink]").addClass("hidden");

              } else if (newStatus === "award") {

                $row.find("[name=RejectAwardButtons]").addClass("hidden");
                $row.find("[name=UndoRejectLink]").addClass("hidden");
                $row.find("[name=UndoAwardLink]").removeClass("hidden");

              } else if (newStatus === "undoreject" || newStatus === "undoaward") {

                $row.find("[name=RejectAwardButtons]").removeClass("hidden");
                $row.find("[name=UndoRejectLink]").addClass("hidden");
                $row.find("[name=UndoAwardLink]").addClass("hidden");

              }

              TECL_UserTenderPresentationEdit.UpdateContinueButtons();

            } else {
              TECL_Master.ShowErrorDialog("Failed to change supplier status.");
            }
          }
        });
      }
    }
  },

  // Update the state of the continue buttons
  UpdateContinueButtons: function() {
    var isValid = TECL_UserTenderPresentationEdit.ValidatePage();
    $("[name=continueBtn]").prop('disabled', !isValid);
  },

  // Show the contact request dialog
  ShowContactRequestDialog: function(tenderSupplierId, supplierEmailAddress) {
    $("#addContactRequestDlgSupplierId").val(tenderSupplierId);
    $("#addContactRequestDlgSupplierEmailAddress").val(supplierEmailAddress);
    $("#addContactRequestDlgDate").val(null);
    $("#addContactRequestDlgTime").val(null);
    $("#addContactRequestDlgMessage").val("");
    $("#addContactRequestDialog").modal({
      backdrop: 'static',
      keyboard: false
    });
    $("#addContactRequestDialog").modal("show");
  },

  // Add a contact request
  AddContactRequest: function() {
    $("#supplierContactDateError").addClass("hidden");
    $("#supplierContactTimeError").addClass("hidden");

    var tenderId = $("#TenderId").val();
    var tenderSupplierId = $("#addContactRequestDlgSupplierId").val();
    var supplierEmailAddress = $("#addContactRequestDlgSupplierEmailAddress").val();
    var date = TECL_DateTime.GetDateTimePickerStringValue($("#addContactRequestDlgDate")); 
    var time =TECL_DateTime.GetDateTimePickerStringValue($("#addContactRequestDlgTime"));
    var message = $("#addContactRequestDlgMessage").val();

    if (TECL_UserTenderPresentationEdit.ValidateContactRequest(tenderId, tenderSupplierId, date, time, message)) {

      if (TECL_Master.AddLock("AddContactRequest")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/AddContactRequest",
          dataType: "json",
          type: "POST",
          data: {
            tenderId: tenderId,
            tenderSupplierId: tenderSupplierId,
            date: date,
            time: time,
            message: message,
            supplierEmailAddress: supplierEmailAddress
          },
          error: function(exc) {
            TECL_Master.ClearLock("AddContactRequest");
          },
          success: function(result) {
            $("#addContactRequestDialog").modal("hide");
            TECL_Master.ClearLock("AddContactRequest");
            if (result && result === true) {
              TECL_Master.DisplayNoticeDlg("Contact request sent to the supplier");
            } else {
              TECL_Master.ShowErrorDialog("Failed to add contact request.");
            }
          }
        });
      }
    }
  },

  // Validate the contact request data
  ValidateContactRequest: function(tenderId, tenderSupplierId, date, time, message) {
    var valid = true;

    if (!tenderId || !tenderSupplierId) {
      valid = false;
    }

    if (!date) {
      $("#supplierContactDateError").removeClass("hidden");
      valid = false;
    }

    if (!message) {
      $("#supplierContactMessageError").removeClass("hidden");
      valid = false;
    }

    return valid;
  },

  // Open and close an supplier notes
  OpenCloseSupplierNotes: function(supplierId) {
    var notesPanel = $("#supplierPrivateNotesPanel_" + supplierId).first();
    var openIcon = $("#notesOpenCloseIcon_" + supplierId).first();
    var openText = $("#notesOpenCloseText_" + supplierId).first();

    if (notesPanel && openIcon) {
      if ($(notesPanel).hasClass("hidden")) {
        $(notesPanel).removeClass("hidden");
        $(openIcon).removeClass("fa-chevron-down");
        $(openIcon).addClass("fa-chevron-up");
        $(openText).html("Hide notes");
      } else {
        $(notesPanel).addClass("hidden");
        $(openIcon).removeClass("fa-chevron-up");
        $(openIcon).addClass("fa-chevron-down");
        $(openText).html("Show notes");
      }
    }
  },

  // Save the notes against a supplier
  SaveSupplierNotes: function(supplierTenderId, noteControlId) {
    var noteText = $("#" + noteControlId).val();

    if (supplierTenderId) {
      if (TECL_Master.AddLock("SaveSupplierNotes")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/SaveSupplierNotes",
          dataType: "json",
          type: "POST",
          data: {
            supplierTenderId: supplierTenderId,
            noteText: noteText
          },
          error: function(exc) {
            TECL_Master.ClearLock("SaveSupplierNotes");
          },
          success: function(result) {
            TECL_Master.ClearLock("SaveSupplierNotes");

            if (result && result === true) {
              TECL_Master.DisplayNoticeDlg("Supplier notes saved.");
            } else {
              TECL_Master.ShowErrorDialog("Failed to save notes");
            }
          }
        });
      }
    }
  }

};
